import { useQuery } from "@apollo/client";
import { LoadingOverlay, Select } from "@mantine/core";
import { useForm } from "@mantine/form";
import { GET_MY_WARE_HOUSES } from "apollo/queries"; // Ensure this is the correct query
import { useEffect, useState } from "react";

export default function WarehouseFilter({ onCardClick, valueType, warehouse }) {
  const [dropDownData, setDropDownData] = useState([]);
  const form = useForm({
    initialValues: {
      retailer: null,
    },
  });
  const { data, loading, refetch } = useQuery(GET_MY_WARE_HOUSES, {
    variables: {
      first: 1000,
      page: 1,
    },
    onCompleted: (data) => {
      const arr = data.myWarehouses.data
        .filter((item) => item.status === "ACTIVE")
        .map((item) => ({
          label: item.name,
          value: valueType === "id" ? item.id : item.name,
        }));

      setDropDownData(arr);
    },
  });
  useEffect(() => {
    refetch();
  }, []);
  const handleProductSelect = (value) => {
    onCardClick(value);
  };

  return (
    <>
      {loading && <LoadingOverlay visible={loading} />}
      <Select
        placeholder="Filter By Warehouse"
        data={dropDownData}
        value={warehouse}
        label="Select Warehouse"
        onChange={(value) => {
          handleProductSelect(value);
        }}
        clearable
        searchable
        withinPortal
      />
    </>
  );
}
